import { render, staticRenderFns } from "./ToolbarApp.vue?vue&type=template&id=196fcbb1&scoped=true&"
import script from "./ToolbarApp.vue?vue&type=script&lang=js&"
export * from "./ToolbarApp.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarApp.vue?vue&type=style&index=0&id=196fcbb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fcbb1",
  null
  
)

export default component.exports